var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEpicGameIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.286 1h11.428A2.285 2.285 0 0 1 16 3.286v11.428A2.285 2.285 0 0 1 13.714 17H2.286A2.285 2.285 0 0 1 0 14.714V3.286A2.285 2.285 0 0 1 2.286 1Zm7.832 2.286H6.286v11.428h3.832V13.37H7.832V9.672h2.218V8.126H7.832V4.63l2.286-.067V3.286Z",
  id: "EpicGameIcon_svg__a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)",
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3B3B3B",
  xlinkHref: "#EpicGameIcon_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#757575",
  xlinkHref: "#EpicGameIcon_svg__a"
}))));

export default SvgEpicGameIcon;